export const VISA_VERIFICATION_ANALYTICS_EVENTS = {
  UPLOAD_VISA_PDF: "upload-visa-pdf",
};
